var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8181 31.3565C12.4701 27.6705 7.92966 25.2829 2.99527 24.6137C2.43362 24.5515 1.91491 24.2835 1.53923 23.8614C1.16355 23.4393 0.957552 22.893 0.96098 22.3279V3.92795C0.961029 3.60077 1.03132 3.27742 1.16709 2.97975C1.30286 2.68208 1.50095 2.41703 1.74798 2.2025C1.99501 1.98798 2.28521 1.82899 2.59897 1.73627C2.91273 1.64356 3.24274 1.61928 3.56669 1.66509C8.28508 2.44819 12.6015 4.79966 15.8181 8.33937V31.3565Z",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8184 31.3565C19.1664 27.6705 23.7068 25.2829 28.6412 24.6137C29.2029 24.5515 29.7216 24.2835 30.0973 23.8614C30.4729 23.4393 30.6789 22.893 30.6755 22.3279V3.92795C30.6755 3.60077 30.6052 3.27742 30.4694 2.97975C30.3336 2.68208 30.1355 2.41703 29.8885 2.2025C29.6415 1.98798 29.3513 1.82899 29.0375 1.73627C28.7237 1.64356 28.3937 1.61928 28.0698 1.66509C23.3514 2.44819 19.035 4.79966 15.8184 8.33937V31.3565Z",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBookIcon);
export default __webpack_public_path__ + "static/media/open-book-icon.c06aaacbc6a94f15a77788d1a8ca6198.svg";
export { ForwardRef as ReactComponent };